/**
 * Builds a URL to a different tenant by replacing the current tenant's slug
 * subdomain with the target tenant's slug. On hosts that don't start with
 * `<currentTenantSlug>.` (e.g. `localhost:3000`), the host is returned
 * unchanged so the link degrades gracefully in dev.
 */
export function getTenantHref(
  currentTenantSlug: string,
  targetTenantSlug: string
): string {
  const host = window.location.host.replace(
    new RegExp(`^${currentTenantSlug}\\.`),
    `${targetTenantSlug}.`
  );
  return `${window.location.protocol}//${host}`;
}
